import React, { SVGProps } from 'react'

const SvgTooltipHover = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={props.fill || 'var(--color-cta)'}
        d="M12.5 20.5a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z"
      />
      <path
        fill={props.fill ? 'var(--color-cta)' : '#FFF'}
        d="M12.375 15.05a.783.783 0 0 0-.774.785c0 .418.336.785.774.785a.792.792 0 0 0 .785-.785.792.792 0 0 0-.785-.785m.133-5.942c-1.376 0-2.008.816-2.008 1.366 0 .397.336.58.612.58.55 0 .326-.784 1.365-.784.51 0 .918.224.918.693 0 .55-.571.867-.908 1.152-.295.255-.682.673-.682 1.55 0 .53.142.682.56.682.5 0 .601-.224.601-.418 0-.53.01-.836.571-1.274.275-.214 1.142-.907 1.142-1.865s-.867-1.682-2.171-1.682"
      />
    </g>
  </svg>
)

export default SvgTooltipHover
